(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('Lot', Lot);

    Lot.$inject = ['$resource', 'DateUtils'];

    function Lot ($resource, DateUtils) {
        var resourceUrl =  'api/lots/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdOn = DateUtils.convertDateTimeFromServer(data.createdOn);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                        data.loadingDate = DateUtils.convertLocalDateFromServer(data.loadingDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.loadingDate = DateUtils.convertLocalDateToServer(data.loadingDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.loadingDate = DateUtils.convertLocalDateToServer(data.loadingDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
